import withLeaveWarn from './withLeaveWarn';
import reducer, {
  setLeaveWarn,
  resetLeaveWarn,
  enableUnloadIgnore,
  disableUnloadIgnore,
} from './reducer';

export {
  withLeaveWarn,
  reducer,
  setLeaveWarn,
  resetLeaveWarn,
  enableUnloadIgnore,
  disableUnloadIgnore,
};
export default {
  withLeaveWarn,
  reducer,
  setLeaveWarn,
  resetLeaveWarn,
  enableUnloadIgnore,
  disableUnloadIgnore,
};



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/components/LeaveWarn/index.js
 **/